var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    x: 4.5,
    y: 4,
    fill: "#E2FFEA",
    rx: 36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    x: 4.5,
    y: 4,
    stroke: "#F4FFF7",
    strokeWidth: 8,
    rx: 36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#51C394",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.143,
    clipPath: "url(#ai_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.824 41.455a18.858 18.858 0 1 1-18.857-18.857M20.109 41.455h21.758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.969 22.598a32.55 32.55 0 0 0-7.254 18.857 32.55 32.55 0 0 0 7.254 18.857A32.55 32.55 0 0 0 45.7 45.808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.77 30.477c-1.1-.188-1.1-1.772 0-1.964a9.982 9.982 0 0 0 8.043-7.7l.063-.305c.242-1.09 1.791-1.1 2.043-.01l.078.356a10.035 10.035 0 0 0 8.065 7.653c1.106.191 1.106 1.785 0 1.98a10.035 10.035 0 0 0-8.065 7.653l-.078.352c-.252 1.087-1.801 1.08-2.043-.01l-.063-.301a9.987 9.987 0 0 0-8.043-7.703Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 18h44v44h-44z"
  })))));
};
export default SvgAi;